import { PAYMENT_MODE, type PaymentMode } from '@/domain/payment/payment-mode'
import { PaymentTiming, PaymentTimingLabel, parsePaymentTiming as _parsePaymentTiming } from '@/types/enums/PaymentTiming'

export { PaymentTiming, PaymentTimingLabel } from '@/types/enums/PaymentTiming'
export {
  inferCodFromPaymentMethod,
  paymentTimingToCode,
  resolvePaymentTimingFromOrder,
} from '@/domain/order/order-payment-timing'

export function parsePaymentTiming(value: unknown): PaymentTiming {
  return _parsePaymentTiming(value)
}

/** Checkout UX selection → API `payment_timing` (single write-path mapping). */
export function resolvePaymentTimingForCheckout(paymentMode: PaymentMode): PaymentTiming {
  if (paymentMode === PAYMENT_MODE.COD) {
    return PaymentTiming.AtDelivery
  }
  return PaymentTiming.BeforeFulfillment
}

export type DeferredPaymentTiming = PaymentTiming.AtDelivery | PaymentTiming.AtPickup

/** COD-style pay-on-fulfillment (cash at delivery or pickup). */
export function isCodPaymentTiming(timing: PaymentTiming): timing is DeferredPaymentTiming {
  return timing === PaymentTiming.AtDelivery || timing === PaymentTiming.AtPickup
}

/** Prepaid / gateway-before-fulfillment orders. */
export function isPrepaidPaymentTiming(timing: PaymentTiming): boolean {
  return timing === PaymentTiming.BeforeFulfillment
}

/**
 * Success-page query: `paymentTiming=AtDelivery` (legacy `payment=cod` still accepted elsewhere).
 */
export function isCodPaymentTimingQueryParam(
  paymentTimingQuery: string | null | undefined,
  legacyPaymentQuery?: string | null | undefined
): boolean {
  const timing = parsePaymentTiming(paymentTimingQuery)
  if (timing !== PaymentTiming.Unknown) {
    return isCodPaymentTiming(timing)
  }
  return String(legacyPaymentQuery ?? '').trim().toLowerCase() === PAYMENT_MODE.COD.toLowerCase()
}

/** Display label for payment timing. */
export function getPaymentTimingLabel(timing: PaymentTiming): string {
  return PaymentTimingLabel[timing]
}
